<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Expenses Categories</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="accent" small to="/new-expense-category">
            <v-icon left dark>mdi-plus</v-icon>New Expense Category
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="categories"
              :search="search"
              :mobile-breakpoint="0"
            >
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn
                  color="editIcon"
                  text
                  :to="`/account/${item.id}`"
                  icon
                  ><v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Category", value: "Name" },
      { text: "Action", value: "action" },
    ],
    categories: [],
  }),
  methods: {
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/expenses-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCategories();
  },
};
</script>